export const odooConfiguration = {
  odoo_configurations: `Oconfiguraciones de odoo`,
  odoo_invoicedate_missing: "La fecha de la factura es obligatoria.",
  odoo_invoiceduedate_missing:
    "La fecha de vencimiento de la factura es obligatoria.",
  odoo_odoovendorid_missing: "El ID del proveedor es obligatorio.",
  odoo_odooaccountjournalid_missing:
    "El ID del diario contable es obligatorio.",
  odoo_odoocurrencyid_missing: "El ID de la moneda es obligatorio.",
  odoo_articles_required: "Se requiere al menos un artículo.",
  odoo_articles_quantity_required: "La cantidad del artículo es obligatoria.",
  odoo_articles_unitprice_required:
    "El precio unitario del artículo es obligatorio.",
  odoo_article_either_itemid_or_acctid_required:
    "Cada artículo debe tener un ID de ítem o un ID de cuenta.",
  odoo_items_required: "Se requiere al menos un ítem.",
  odoo_item_quantity_missing: "La cantidad del ítem es obligatoria.",
  odoo_item_unitprice_missing: "El precio unitario del ítem es obligatorio.",
  odoo_item_either_itemid_or_acctid_required:
    "Cada ítem debe tener un ID de ítem o un ID de cuenta.",
};
